module.exports = __webpack_public_path__ + "img/untitled-2.60c40f51.webp";